import { Loading } from '../../Loading'
import { EmptyStateSkeleton } from '../../ui/empty-state-skeleton'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../ui/tooltip'

interface NumericMetricProps {
  title: string
  value: string
  tooltip: string
  isLoading: boolean
  hasData?: boolean
}

export const NumericMetric = ({
  title,
  value,
  tooltip,
  isLoading,
  hasData,
}: NumericMetricProps) => {
  return (
    <Loading isLoading={isLoading} modalView>
      {hasData ? (
        <div className='flex flex-col h-full min-h-0 p-3 rounded-lg'>
          <div className='flex items-center justify-between'>
            <div className='text-[1.125rem] font-semibold text-muted-foreground'>{title}</div>
          </div>
          <div className='flex flex-col items-center justify-center flex-1'>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger
                  render={<div className='text-2xl font-bold text-primary text-center' />}
                >
                  {value}
                </TooltipTrigger>
                <TooltipContent>
                  <p>{tooltip}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
            <div className='text-sm mt-2 text-muted-foreground'>All time</div>
          </div>
        </div>
      ) : (
        <div className='flex flex-col h-full min-h-0 p-3 rounded-lg'>
          <div className='flex flex-col flex-1 min-h-0'>
            <EmptyStateSkeleton title='No data to display' className='h-full' />
          </div>
        </div>
      )}
    </Loading>
  )
}
